import React, { useContext, useState, useEffect } from "react";
import { Button, Card, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter } from "reactstrap";
import { CallContext } from "context/CallContex";
import { SignalRNotificationContext } from "context/SignalRNotificationContext";
import CallComponent from "./V1/CallComponent";
import DispatchRequestCard from "./DispatchRequestCard";
import { useTwilioDevice } from "./V1/useTwilioDevice";
import { useAuth0 } from "react-auth0-spa";
import history from "utils/history";
import { UserContext } from "context/UserContext";
import AgentService from "core/api/AgentService";
import { redirectToPath, paths } from "utils/PathService";

export default function CallPopup() {

    const { calls, setCalls } = useContext(CallContext)
    const { dispatchRequests, removeDispatchRequest } = useContext(SignalRNotificationContext)
    const { userData, setUserStatus } = useContext(UserContext)
    const { user } = useAuth0();

    const {
        makeOutgoingCall,
        acceptCall,
        rejectCall,
        endCall,
        muteCall,
        getActiveCall,
        acceptIncomingCall,
        holdCall,
        sendDtmfTones
    } = useTwilioDevice();

    const currentCalls = calls.filter(call => call.callStatus == "Active" || call.callStatus == "OnHold" || call.callStatus == "Muted")
    const incomingCalls = calls.filter(call => call.callStatus == "Incoming" || call.callStatus == "Outgoing")


    const [chooseCallReportPopup, setChooseCallReportPopup] = useState({ visible: false, newReport: null, oldReport: null })
    const [showKeypadForCall, setShowKeypadForCall] = useState(null)
    const [additionalDigits, setAdditionalDigits] = useState("");
    const [dispatchTaken, setDispatchTaken] = useState(false);

    const handleDispatchAccept = (request) => {
        removeDispatchRequest(request.callId);
        if (userData.status === "Online") {
            AgentService.addUserLog({ UserEmail: user.email, Status: "Busy", LogDate: new Date() });
            setUserStatus("Busy");
        }
    };

    const handleDispatchClick = async (request) => {
        if (request.acceptedBy === user.email) {
            handleDispatchAccept(request);
            redirectToPath(paths.dispatch911Report(request.callId));
        } else {
            try {
                const accepted = await AgentService.acceptDispatch({ Id: request.callId, UserEmail: user.email });
                if (accepted) {
                    handleDispatchAccept(request);
                    redirectToPath(paths.dispatch911Report(request.callId));
                } else {
                    setDispatchTaken(true);
                    removeDispatchRequest(request.callId);
                }
            } catch (err) {
                console.error("Failed to accept dispatch:", err);
                alert("Failed to accept dispatch. Please try again.");
            }
        }
    };

    const openCallKeypad = (callSid, phoneNumber) => {
        if (showKeypadForCall?.callID == callSid) {
            setShowKeypadForCall(null)
        } else {
            setShowKeypadForCall({ callID: callSid, number: phoneNumber })
        }

        setAdditionalDigits("")
    }

    const sendDTMF = (tone) => {
        const call = calls.find(c => c?.call?.parameters?.CallSid == showKeypadForCall.callID)
        sendDtmfTones(call.call, tone)
        setAdditionalDigits(prevDigits => prevDigits + tone)
    }

    const answerIncomingCall = async (callData) => {

        const devices = await navigator.mediaDevices.enumerateDevices();
        const audioInputDevices = devices.filter(device => device.kind === 'audioinput');

        if (audioInputDevices.length === 0) {
            alert('No audio input device found. Please connect a microphone and try again.');
        } else {


            await acceptIncomingCall(callData, user.email)

            if (userData.status == "Online") {
                await AgentService.addUserLog({ UserEmail: user.email, Status: "Busy", LogDate: new Date() })
                setUserStatus("Busy")
            }

            const id = callData.elevatorReportID

            if (id) {
                const acceptCallResults = await AgentService.acceptIncomingCall({ Id: id, UserEmail: user.email })

                if (acceptCallResults.otherCall == null) {
                    await openCallReport(acceptCallResults.call)
                } else {
                    setChooseCallReportPopup({ visible: true, newReport: acceptCallResults.call, oldReport: acceptCallResults.otherCall })
                }

            }
        }
    }

    const openCallReport = async (data) => {
        if (data.status == "received") {
            await AgentService.updateCall({ ...data, status: "answered", UserEmail: user.email, DateTimeAnswered: new Date() })
        }

        if (!history.location.pathname.includes(`/call/${data.id}`)) {
            redirectToPath(paths.call(data.id))
        }
    }

    const openReport = async (type) => {

        if (type == "new") {
            openCallReport(chooseCallReportPopup.newReport)
        } else {
            //update call elevator report id
            setCalls((prevCalls) => {
                return prevCalls.map((c) => c.call.parameters.CallSid == chooseCallReportPopup.newReport.dialCallSid ? { ...c, elevatorReportID: chooseCallReportPopup.oldReport.id } : c)

            });

            //update new report so only current user will see this report and could terminate it if doesnt end up using it
            await AgentService.updateCall({ ...chooseCallReportPopup.newReport, status: "answered", UserEmail: user.email, DateTimeAnswered: new Date() })

            openCallReport(chooseCallReportPopup.oldReport)
        }
    }

    // Clear keypad state when the associated call ends
    useEffect(() => {
        if (showKeypadForCall) {
            const callStillExists = calls.some(
                c => c.call.parameters.CallSid === showKeypadForCall.callID
            );

            if (!callStillExists) {
                setShowKeypadForCall(null);
                setAdditionalDigits("");
            }
        }
    }, [calls, showKeypadForCall]);

    return (
        <>
            {(calls.length > 0 || dispatchRequests.length > 0) && 
                <>
                    {showKeypadForCall &&
                    <Card style={{ width: 180, backgroundColor: "white", position: "fixed", bottom: 40, right: 325, display: "flex", zIndex: 1000, paddingTop: 10, paddingBottom: 10 }}>
                            <div>
                                <p style={{ fontWeight: "bold", textAlign: "center" }}>{showKeypadForCall.number}</p>
                                <div style={{ width: 180, height: 35, display: "flex", alignItems: "baseline", justifyContent: "space-between", paddingRight: 10, paddingLeft: 10 }}>
                                    <p style={{ fontSize: 18, flex: 1, textAlign: "center", overflow: "hidden", textOverflow: "ellipsis" }}>{additionalDigits}</p>
                                {/* <i className="las la-backspace" style={{ fontSize: 20 }} onClick={() => { setAdditionalDigits(prevDigits => prevDigits.slice(0, -1)) }}></i> */}
                                </div>
                            </div>
                            <div
                                style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", columnGap: "2px", rowGap: "10px", justifyItems: "center" }} >

                                {["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"].map((tone) => (
                                    <Button
                                        key={tone}
                                        className="btn-fab btn-icon btn-round"
                                        style={{ padding: 0, margin: 0 }}
                                        onClick={() => sendDTMF(tone)}
                                    >
                                        {tone}
                                    </Button>
                                ))}

                        </div>
                        </Card>
                    }
                    <Card style={{ width: 300, backgroundColor: "white", position: "fixed", bottom: 40, right: 20, display: "flex", zIndex: 1000, paddingTop: 10 }}>


                    {currentCalls.length > 0 &&
                        <>
                            <div className="title" style={{ fontSize: 16, textAlign: "Center", }}>Current Calls:</div>
                            <ListGroup flush>
                                {currentCalls.map((callData, index) => (
                                    <ListGroupItem key={callData.call.parameters.CallSid} >
                                        <CallComponent
                                            key={index}
                                            callData={callData}
                                            acceptCall={acceptCall}
                                            rejectCall={rejectCall}
                                            endCall={endCall}
                                            muteCall={muteCall}
                                            getActiveCall={getActiveCall}
                                            acceptIncomingCall={acceptIncomingCall}
                                            holdCall={holdCall}
                                            answerIncomingCall={answerIncomingCall}
                                            showKeypad={showKeypadForCall?.callID === callData.call.parameters.CallSid}
                                            setShowKeypad={openCallKeypad}
                                        />
                                    </ListGroupItem>
                                ))}

                            </ListGroup>
                        </>
                    }
                    {incomingCalls.length > 0 && 

                        <>

                        <div className="title" style={{ fontSize: 16, textAlign: "Center", paddingTop: currentCalls.length > 0 ? 5 : 0 }}>Incoming Calls:</div>
                        <ListGroup flush>
                            {incomingCalls.map((callData, index) => (
                                <ListGroupItem key={callData.call.parameters.CallSid} >
                                    <CallComponent
                                        key={index}
                                        callData={callData}
                                        acceptCall={acceptCall}
                                        rejectCall={rejectCall}
                                        endCall={endCall}
                                        muteCall={muteCall}
                                        getActiveCall={getActiveCall}
                                        acceptIncomingCall={acceptIncomingCall}
                                        holdCall={holdCall}
                                        answerIncomingCall={answerIncomingCall}
                                    />
                                </ListGroupItem>
                            ))}

                            </ListGroup>
                        </>
                    }
                    {dispatchRequests.length > 0 &&
                        <>
                            <div className="title" style={{ fontSize: 16, textAlign: "Center", paddingTop: (currentCalls.length > 0 || incomingCalls.length > 0) ? 13 : 0 }}>Dispatch Requests:</div>

                            <ListGroup flush>
                                {dispatchRequests.map((request) => (
                                    <ListGroupItem key={request.callId}>
                                        <DispatchRequestCard
                                            request={request}
                                            onHandle={handleDispatchClick}
                                        />
                                    </ListGroupItem>
                                ))}
                        </ListGroup>
                        </>
                    }
                </Card>
            </>
              } 

            <Modal isOpen={chooseCallReportPopup.visible} centered={true} >
                <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }} >
                    < div className="title" style={{ fontSize: 18 }}>There is an open report for this Elevator</div>
                    <p style={{ fontSize: 16 }}>Do you want to open a new report or continue the open one?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { openReport("old"); setChooseCallReportPopup({ visible: false, newReport: null, oldReport: null }) }} style={{ margin: "auto", display: "block" }} >Continue Open Report</Button>
                    <Button color="primary" onClick={() => { openReport("new"); setChooseCallReportPopup({ visible: false, newReport: null, oldReport: null }) }} style={{ margin: "auto", display: "block" }} >New Report</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={dispatchTaken} centered={true} >
                <ModalBody style={{ justifyContent: "center", alignContent: "center", textAlign: "center" }} >
                    <div className="title">Dispatch Already Taken</div>
                    <i className="las la-user-check" style={{ fontSize: 50 }}></i>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => setDispatchTaken(false)} style={{ margin: "auto", display: "block" }} >OK</Button>
                </ModalFooter>
            </Modal>
        </>


    )
}

